import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McdClaimLineList = ({ mcdClaimObj: mcdClaim }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!mcdClaim) return;

    rowsReq.partition = mcdClaim.partition;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('rbtPeriodId', mcdClaim.rbtPeriodId, 'mcdClaimId', mcdClaim.id));
  }, [mcdClaim?.partition, mcdClaim?.id]);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Claim Lines come from system only
  }

  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    // fieldToFieldDef.stateId.precedence = 0;
    // fieldToFieldDef.stateId.hasName = false;

    // fieldToFieldDef.invPeriodId.precedence = 3;
    // fieldToFieldDef.invPeriodId.hasName = false;

    fieldToFieldDef.rbtPeriodId.precedence = 4;
    fieldToFieldDef.rbtPeriodId.hasName = false;

    fieldToFieldDef.prodId.precedence = 5;
    fieldToFieldDef.prodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;

    // 3. Units
    fieldToFieldDef.invUnits.precedence = 2000;
    fieldToFieldDef.openDispUnits.precedence = 2001;
    fieldToFieldDef.calcDispUnits.precedence = 2002;
    fieldToFieldDef.dueUnits.precedence = 2003;
    fieldToFieldDef.paidUnits.precedence = 2004;

    // 4. URAs
    fieldToFieldDef.invUra.precedence = 3000;
    fieldToFieldDef.calcUra.precedence = 3001;

    // 5. Amounts
    fieldToFieldDef.invAmt.precedence = 4001;
    fieldToFieldDef.dispAmt.precedence = 4003;
    fieldToFieldDef.dueAmt.precedence = 4004;
    fieldToFieldDef.paidAmt.precedence = 4005;
  }

  return (
    <EntityList 
      entity="MCD_CLAIM_LINE" 
      augRowsReq={augRowsReq} 
      augTabButtons={augTabButtons}
      augFieldDefs={augFieldDefs}
    />
  )
}
